import { cx } from '@emotion/css';
import {
  Dialog,
  Divider,
  InputAdornment,
  MenuItem,
  Select,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {
  AccountBox,
  Brightness1,
  PersonRounded,
  Room,
  Search,
  TuneRounded as Tune,
} from '@material-ui/icons';
import RoomIcon from '@material-ui/icons/Room';
import Skeleton from '@material-ui/lab/Skeleton';
import { getStudentGoal } from '@webapps/business';
import {
  getBusinessPartners,
  getGoals,
  getSchoolsPartners,
  getStudentsCVTeque,
} from '@webapps/business';
import {
  FormikAutocomplete,
  FormikTextField,
  FormikTextField50,
  FormikTextFieldPx,
  ModalSideBar,
  Pagination,
  PaginationNumbers,
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';

import CvTheque from 'components/Icons/CvTheque';
import HourglassHalf from 'components/Icons/HourglassHalf';
import Parcours from 'components/Icons/Parcours';
import PartnerIcon from 'components/Icons/PartnerIcon';
import Team from 'components/Icons/Team';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

import Detailed from './detailed';
import FiltersCV from './FiltersCV';
import CitySearchDropdown from 'components/CitySearchDropdown';
import theme from '../theme';
import Nodata from 'components/NoData';
import StudentCardSkeleton from './StudentCardSkeleton';

const defaultInitialValues = {
  keyword: '',
  partners: [],
  cities: '',
  degrees: [],
  domains: [],
  goals: [],
  jobDomain: [],
  jobs: [],
  desiredContractLength: '',
  certifiedProfile: 'all',
};

const filterSchema = yup?.object().shape({
  keyword: yup?.string(),
  partners: yup?.array(),
  cities: yup?.string(),
  degrees: yup?.array(),
  goals: yup?.array(),
  jobDomain: yup?.array(),
  jobs: yup?.array(),
  desiredContractLength: yup?.string().nullable(true),
  domains: yup?.array(),
  certifiedProfile: yup?.string(),
});

// eslint-disable-next-line react/prop-types
const Content = ({ partnersList}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const { idUser, profile } = useAuth();
  const [keywordRequest, setKeywordRequest] = useState('');
  const [partnersRequest, setPartnersRequest] = useState(partnersList);
  const [citiesRequest, setCitiesRequest] = useState('');
  const [degreesRequest, setDegreesRequest] = useState('');
  const [goalsRequest, setGoalsRequest] = useState('');
  const [jobDomainRequest, setJobDomainRequest] = useState('');
  const [jobsRequest, setJobsRequest] = useState('');
  const [desiredContractLengthRequest, setDesiredContractLengthRequest] =
    useState('');
  const [domainsRequest, setDomainsRequest] = useState('');
  const [certifiedProfileRequest, setCertifiedProfileRequest] = useState();

  const {
    status: load,
    data: { content: students = [], totalElements } = {},
    isFetching,
  } = useQuery(getStudentsCVTeque, {
    key: [
      'studentCVTheque',
      keywordRequest +
      partnersRequest +
      citiesRequest +
      degreesRequest +
      goalsRequest +
      jobDomainRequest +
      jobsRequest +
      desiredContractLengthRequest +
      domainsRequest +
      certifiedProfileRequest +
      page,
    ],
    variables: {
      keyword: keywordRequest,
      partners: partnersRequest || partnersList,
      cities: citiesRequest,
      trainingDegrees: degreesRequest,
      goals: goalsRequest,
      jobDomain: jobDomainRequest,
      jobs: jobsRequest,
      desiredContractLength: desiredContractLengthRequest,
      trainingDomains: domainsRequest,
      certifiedProfile: certifiedProfileRequest,
      page: page - 1,
      size,
      type: profile === 'SCHOOL' ? 'school' : 'business',
      id: idUser,
      freeStudent:
        partnersList?.split(',').length ===
        partnersRequest?.split(',').length || !partnersRequest,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const [info, setInfo] = useState({});
  const [open, setOpen] = useState(false);
  const [waitResult, setWaitResult] = useState(false);

  useEffect(() => {
    if (students?.length) {
      setInfo(students[0]);
    }
  }, [students?.length]);

  const handleOffer = (value) => {
    setInfo(value);
    setOpen(true);
  };

  const handleClick = (value) => {
    setInfo(value);
  };

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const StudentGoal = ({ id, style, textStyle }) => {
    const {
      css,
      classes,
      cx,
      global,
      theme: { spacing },
    } = useStyles(styles);
    const { data: myGoal = [] } = useQuery(getStudentGoal, {
      key: ['myGoal', id],
      variables: { id },
    });

    const getLabel = (label) => {
      switch (label) {
        case 'Trouver un stage':
          return 'Recherche : Stage';
        case 'Trouver une alternance':
          return 'Recherche : Alternance';
        case 'Trouver une formation':
          return 'Recherche : Formation';
        case 'Trouver une formation et un stage':
          return 'Recherche : Formation & Stage';
        case 'Trouver une formation et une alternance':
          return 'Recherche : Formation & Alternance';
        default:
          return 'En recherche : Non renseigné';
      }
    };

    return (
      <div className={cx(global.infoText, cx(global.infoText, classes.address))}>
        <Search className={global.infoIcon} style={style} />
        <div style={textStyle}>{getLabel(myGoal?.label)}</div>
      </div>
    );
  };

  const formik = useFormik({
    initialValues: defaultInitialValues,
    validationSchema: filterSchema,
    onSubmit: ({
      certifiedProfile,
      cities,
      degrees,
      domains,
      goals,
      jobDomain,
      jobs,
      desiredContractLength,
      keyword,
      partners,
    }) => {
      setKeywordRequest(keyword);
      setPartnersRequest(partners?.map(({ id }) => id).join());
      setCitiesRequest(cities);
      setDegreesRequest(degrees?.map(({ id }) => id).join());
      setGoalsRequest(goals?.map(({ id }) => id).join());
      setJobDomainRequest(jobDomain?.map(({ id }) => id).join());
      setJobsRequest(jobs?.map(({ ogr }) => ogr).join());
      setDesiredContractLengthRequest(desiredContractLength);
      setDomainsRequest(domains?.map(({ id }) => id).join());
      setCertifiedProfileRequest(certifiedProfile);
      setPage(1);
    },
  });

  const {
    data: { content: partnersBusiness = [] } = {},
    isLoading: isLoadingGetMySchools,
  } = useQuery(getBusinessPartners, {
    key: ['businessPartners', idUser],
    variables: {
      id: idUser,
      type: 'accepted',
      page: 0,
      size: 2000,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const [filterCVOpened, setFilterCVOpened] = useState(false);

  const handleFilterCVClose = () => {
    setFilterCVOpened(false);
  };

  const handleFilteCVOpen = () => {
    setFilterCVOpened(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const { data: goals = [], isLoading: isLoadingGoals } = useQuery(getGoals, {
    key: 'allGoals',
  });

  const {
    images: { Billings }
  } = theme

  const getLabel = (label) => {
    switch (label) {
      case 'Trouver un stage':
        return 'En recherche de stage';
      case 'Trouver une alternance':
        return "En recherche d'une alternance";
      case 'Trouver une formation':
        return "En recherche d'une formation";
      case 'Trouver une formation et un stage':
        return "En recherche d'une formation et d'un stage";
      case 'Trouver une formation et une alternance':
        return "En recherche d'une formation et d'une alternance";
      default:
        return 'En recherche de stage';
    }
  };

  const isLoading = load === 'loading' || isFetching || isLoadingGetMySchools || isLoadingGoals;


  return (
    <Grid container style={{ columnGap: '30px' }} className={cx(global.containerNoScroll, classes.container)} >
      <Grid container xs={12} sm={12} md={12} lg={4} xl={4} className={classes.leftContainer} direction="column">
        <Grid container direction="column" style={{ height: '100%', flexWrap: 'nowrap' }}>
          <div style={{ display: 'flex', flexDirection: 'column', padding: '20px', rowGap: '10px' }}>
            <Grid container className={classes.filterContainer} >
              <Grid item xs>
                <FormikTextFieldPx
                  borderRadius={6}
                  formik={formik}
                  fullWidth
                  label="Prénom et nom"
                  name="keyword"
                  variant="outlined"
                  endAdornment={
                    <InputAdornment position="end">
                      <PersonRounded style={{ color: '#5D75A8' }} />
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs>
                <CitySearchDropdown formik={formik} />
              </Grid>
            </Grid>
            <Grid container className={classes.filterContainer} >
              {profile !== 'SCHOOL' && (
                <Grid item xs>
                  <FormikAutocomplete
                    borderRadius={6}
                    formik={formik}
                    getOptionLabel={(option) => option?.name || ''}
                    label="Mes partenaires"
                    loading={isLoadingGetMySchools}

                    loadingText={
                      <>
                        <FormattedMessage id="loading" />
                        ...
                      </>
                    }
                    multiple
                    classes={{
                      popupIndicator: css({
                        transform: 'none',
                      }),
                    }}
                    name="partners"
                    popupIcon={
                      <PartnerIcon height={24} width={24} color="#5D75A8" />
                    }
                    options={partnersBusiness}
                    value={formik.values.partners}
                    variant="outlined"
                  />
                </Grid>
              )}
              {profile === 'BUSINESS' && (
                <Grid item xs>
                  <FormikAutocomplete
                    borderRadius={6}
                    formik={formik}
                    fullWidth
                    getOptionLabel={(option) => getLabel(option.label) || ''}
                    label="Parcours souhaité"
                    loading={isLoadingGoals}
                    loadingText={
                      <>
                        <FormattedMessage id="loading" />
                        ...
                      </>
                    }
                    multiple
                    name="goals"
                    options={goals}
                    popupIcon={<Parcours color="#5D75A8" />}
                    value={formik.values.goals}
                    variant="outlined"
                  />
                </Grid>
              )}
              {profile !== 'BUSINESS' && (
                <Grid item xs>
                  <FormikAutocomplete
                    borderRadius={6}
                    formik={formik}
                    getOptionLabel={(option) => getLabel(option.label) || ''}
                    label="Parcours souhaité"
                    loading={isLoadingGoals}
                    loadingText={
                      <>
                        <FormattedMessage id="loading" />
                        ...
                      </>
                    }
                    multiple
                    name="goals"
                    options={goals}
                    popupIcon={<Parcours color="#5D75A8" />}
                    value={formik.values.goals}
                    variant="outlined"
                  />
                </Grid>
              )}
              {profile === 'SCHOOL' && (
                <Grid item xs>
                  <Button
                    className={classes.filterButton}
                    color="primary"
                    onClick={handleFilteCVOpen}
                    variant="outlined"
                    fullWidth
                  >
                    <Tune
                      style={{ fontSize: '25px', marginRight: spacing(1) }}
                    />
                    <FormattedMessage id="filter" />
                  </Button>
                </Grid>
              )}
            </Grid>

            {profile === 'BUSINESS' && (
              <Grid item xs>
                <Button
                  className={classes.filterButton}
                  color="primary"
                  fullWidth
                  onClick={handleFilteCVOpen}
                  variant="outlined"
                >
                  <Tune style={{ fontSize: '25px', marginRight: spacing(1) }} />
                  <FormattedMessage id="filter" />
                </Button>
              </Grid>
            )}
            <Grid item xs>
              <Button
                className={css({
                  borderRadius: '6px !important',
                })}
                color="primary"
                fullWidth
                onClick={formik.handleSubmit}
                variant="contained"
              >
                <FormattedMessage id="btnSearch" />
              </Button>
            </Grid>
          </div>
          <Divider fullWidth />
          <Grid item container xs direction="column" className={classes.nowrap}>
            {load === 'loading' || isFetching ? (
              <>
                  {[...Array(size/2)].map((_, idx) => (
                  <StudentCardSkeleton key={idx} />
                ))}
              </>
            ) : (students && students.length > 0) ? (
              students.map((item, index) => (
                <>
                  <div className={classes.desktop}>
                    <Grid
                      key={index}
                      className={`${classes.displayDesktop} ${item.id === info.id && classes.displayDesktopSelected}`}
                      container
                      onClick={() => handleClick(item)}
                    >
                      <div className={css({ display: 'flex', alignItems: 'center' })}>
                        <AvatarStudent
                          applicant={item}
                          height={80}
                          width={80}
                        />
                        <Grid item style={{ marginLeft: spacing(1.5) }}>
                          <div style={{ marginLeft: spacing(1) }} className={global.title}>
                            {item.firstname} {item.lastname}
                          </div>
                          <div className={cx(global.infoText, classes.address)}>
                            <RoomIcon
                              style={{
                                marginRight: spacing(0.5),
                                color:
                                  item.id === info.id
                                    ? '#0060F9'
                                    : '#5D75A8',
                              }}
                              className={global.infoIcon}
                            />
                            <div
                              style={{
                                color:
                                  item.id === info.id
                                    ? '#152652'
                                    : '#5D75A8',
                              }}
                            >
                              {item?.address?.city}{' '}
                              {item?.address?.cityCode}
                            </div>
                          </div>
                          <StudentGoal
                            id={item?.id}
                            style={{
                              marginRight: spacing(0.5),
                              color:
                                item.id === info.id
                                  ? '#0060F9'
                                  : '#5D75A8',
                            }}
                            textStyle={{
                              color:
                                item.id === info.id
                                  ? '#152652'
                                  : '#5D75A8',
                            }}
                          />
                          <div className={cx(global.infoText, classes.address)}>
                            <HourglassHalf
                              className={`${global.infoIcon} ${item.id === info.id
                                ? classes.iconHighlighted
                                : ''
                                }`}
                            />
                            <span
                              style={{
                                color:
                                  item.id === info.id
                                    ? '#152652'
                                    : '#5D75A8',
                              }}
                            >
                              Durée souhaitée :{' '}
                              {students.find(
                                (student) => student.id === item.id
                              )
                                ? students.find(
                                  (student) => student.id === item.id
                                ).desiredContractLength
                                  ? ' ' +
                                  students.find(
                                    (student) =>
                                      student.id === item.id
                                  ).desiredContractLength +
                                  ' mois'
                                  : 'Non renseignée'
                                : 'Chargement...'}
                            </span>
                          </div>
                        </Grid>
                      </div>
                    </Grid>
                    {index !== students?.length - 1 && (
                      <Divider
                        style={{
                          marginTop: '10px',
                          marginBottom: '10px',
                        }}
                      />
                    )}
                  </div>
                  {/* Mobile */}
                  <Grid
                    key={index}
                    className={classes.displayMobile}
                    container
                    item
                    onClick={() => handleOffer(item)}
                    xs={12}
                  >
                    <div
                      className={css({
                        margin: spacing(2),
                        display: 'flex',
                      })}
                    >
                      <AvatarStudent
                        applicant={item}
                        height={80}
                        width={80}
                      />
                      <Grid item xs>
                        <div style={{ marginLeft: spacing(1) }} className={global.title}>
                          {item.firstname} {item.lastname}
                        </div>
                        <div className={cx(global.infoText, classes.address)}>
                          <RoomIcon
                            className={global.infoIcon}
                          />
                          <div style={{ color: '#5D75A8' }}>
                            {item?.address?.city}{' '}
                            {item?.address?.cityCode}
                          </div>
                        </div>
                        <div
                          className={css({
                            marginTop: spacing(1),
                            marginBottom: spacing(1),
                          })}
                        >
                          <StudentGoal
                            id={item?.id}
                            style={{
                              marginRight: spacing(0.5),
                              color: '#5D75A8',
                            }}
                            textStyle={{ color: '#5D75A8' }}
                          />
                        </div>
                        <div className={cx(global.infoText, classes.address)} key={index}>
                          <HourglassHalf className={global.infoIcon} />
                          <span>
                            Durée souhaitée :{' '}
                            {students.find(
                              (student) => student.id === item.id
                            )
                              ? students.find(
                                (student) => student.id === item.id
                              ).desiredContractLength
                                ? ' ' +
                                students.find(
                                  (student) => student.id === item.id
                                ).desiredContractLength +
                                ' mois'
                                : 'Non renseignée'
                              : 'Chargement...'}
                          </span>
                        </div>
                      </Grid>
                    </div>
                    <Divider
                      style={{
                        marginTop: '10px',
                        marginBottom: '10px',
                        width: '100%',
                      }}
                    />
                  </Grid>
                </>
              ))
            ) : (
              <Nodata
                image={Billings}
                contentWidth='70%'
                padding='0px 20px 20px 0px'
                title="Aucun profil trouvé"
                description="Essayez d'ajuster vos filtres pour trouver plus de résultats."
              />
            )}
            {(students?.length > 0 && totalElements > 10) && (
              <div
                className={css({
                  paddingBottom: spacing(2.5),
                  marginTop: spacing(2.5),
                  '@media only screen and (max-width:768px)': {
                    marginTop: 0,
                  },
                })}
              >
                <PaginationNumbers
                  onChange={handlePaginationChange}
                  page={page}
                  pageCount={size}
                  totalCount={totalElements}
                />
              </div>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs
        style={{
          height: '100%',
          overflow: 'auto',
          backgroundColor: 'white',
          borderRadius: 10,
        }}
        className={cx(
          classes.details,
          classes.desktop,
        )}
      >
        <Detailed info={info} closeModal={closeModal} />
      </Grid>
      <Dialog
        fullScreen
        className={classes.detailsModal}
        onClose={closeModal}
        open={open}
      >
        <Detailed info={info} closeModal={closeModal} isLoading={isLoading} />
      </Dialog>
      <ModalSideBar
        handleClose={handleFilterCVClose}
        open={filterCVOpened}
        title="Filtres"
        width="400px"
      >
        <FiltersCV formik={formik} />
      </ModalSideBar>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: 'flex',
    '@media screen and (max-width: 1199px)': {
      overflow: 'visible',
      padding: '20px',
    },
  },
  nowrap: {
    height: '100%',
    overflow: 'auto',
    flexWrap: 'nowrap',
    // padding: '20px',
    '@media screen and (max-width: 768px)': {
      overflow: 'visible',
    },
  },
  leftContainer: {
    background: 'white',
    display: 'flex',
    height: '100%',
    borderRadius: 10,
  },
  filterContainer: {
    columnGap: '10px',
    '@media screen and (max-width: 1023px)': {
      flexDirection: 'column',
      rowGap: '10px',
    },
  },
  inputRowGap: {
    rowGap: '10px',
  },
  filterButton: {
    borderRadius: 6,
    fontWeight: 600,
    border: '1px solid #C0D9FF',
    backgroundColor: '#F3F7FF',
    color: '#5A6DA1',
    '&:hover': {
      border: '1px solid #C0D9FF',
      backgroundColor: '#F3F7FF',
      filter: 'brightness(0.9)',
    },
  },
  desktop: {
    '@media only screen and (max-width:1200px)': { display: 'none' },
  },
  displayMobile: {
    border: '1px solid #F3F7FF',
    '@media only screen and (min-width:1201px)': { display: 'none' },
    marginBottom: spacing(2),
    backgroundColor: 'white',
    borderRadius: 10,
  },
  address: {
    margin: 5,
    display: 'flex',
    alignItems: 'center',
  },
  displayDesktop: {
    padding: '20px 0 20px 20px',
    width: 'calc(100% - 40px)',
    cursor: 'pointer',
    margin: '20px',
    display: 'flex',
    alignItems: ' center',
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: '#F3F7FF',
    },
  },
  displayDesktopSelected: {
    backgroundColor: '#F3F7FF',
    '&:hover': {
      backgroundColor: '#F3F7FF',
    },
  },
  iconHighlighted: {
    color: '#0060f9',
  },
});

Content.propTypes = {
  partnersList: PropTypes.string,
};

export default Content;
